{
  "startNew": "Start New",
  "table": {
    "createdAt": "Ran At",
    "createdBy": "Ran by",
    "state": "State",
    "organization": "Organization"
  },
  "fileTable": {
    "order": "Order",
    "createdAt": "Uploaded At",
    "name": "Name",
    "type": "Import Type",
    "totalLineItems": "# Lines",
    "queuedLineItems": "# Queued",
    "failedLineItems": "# Failed",
    "processedLineItems": "# Processed",
    "state": "State",
    "actions": "Actions",
    "menu": {
      "delete": "Delete",
      "process": "Process"
    }
  },
  "resumeProcessButton": "Resume",
  "processBulkImportMessage": "Bulk import is being processed.",
  "deleteFileMessage": "File has been deleted.",
  "resumeFileConfirmationDialog": {
    "title": "Resume file processing",
    "text": "Are you sure you want to resume the file processing?"
  },
  "deleteFileConfirmationDialog": {
    "title": "Delete file",
    "text": "Are you sure you want to delete the file?"
  },
  "lineItemTable": {
    "externalId": "Line Item id",
    "oneVestId": "OneVest id",
    "state": "State"
  },
  "fileTypes": {
    "USER": "Clients",
    "GOAL": "Goals",
    "ACCOUNT": "Accounts",
    "ACCOUNT_AFFILIATE": "Account affiliates",
    "TRANSACTION": "Transactions",
    "SECURITY_PRICE": "Historical Security Prices",
    "PRODUCT_SHELF": "Product Shelf",
    "FOREIGN_EXCHANGE_RATE": "Foreign Exchange Rates",
    "PORTFOLIO_SECURITIES": "Portfolio Securities"
  },
  "states": {
    "INITIATED": "INITIATED",
    "PROCESSING": "PROCESSING",
    "FAILED": "FAILED",
    "CANCELED": "CANCELED",
    "COMPLETED": "COMPLETED",
    "QUEUED": "QUEUED",
    "PARTIALLY_FAILED": "PARTIALLY FAILED",
    "PROCESSED": "PROCESSED"
  },
  "lineItemModal": {
    "title": "Line Item Details",
    "errorTitle": "Errors",
    "errorCode": "Code",
    "errorField": "Field",
    "errorDescription": "Description",
    "save": "Save",
    "addBackToQueue": "Add item back to queue"
  },
  "addFile": "Add file",
  "addFileModal": {
    "title": "Add Import file",
    "type": "Import Type",
    "downloadTemplateButton": "Download template",
    "button": "Upload"
  },
  "bulkImportOn": "Imported On",
  "notSureHowToFormat": "Not sure how to format your CSV? Use our",
  "template": "template",
  "copyAndPaste": "Copy and paste securities",
  "errorFetchingTemplate": "Error fetching template: {{error}}",
  "downloadTemplate": "Download Template",
  "importCsvFile": "Import CSV File",
  "pasteDescription": "Import a CSV file to quickly add securities to your portfolio. Please ensure your CSV includes the following columns: Security Identifier (Ticker), Target Weight %, Tax Rank (optional).",
  "pasteCsv": "Paste CSV",
  "pastePlaceholder": "",
  "errors": {
    "emptyPaste": "Please paste CSV content",
    "invalidContent": "Invalid CSV content: {{error}}",
    "processFailed": "Failed to process pasted content",
    "unknownError": "Unknown error"
  },
  "success": {
    "imported": "{{fileName}} imported successfully",
    "uploaded": "Document uploaded successfully: {{fileName}}"
  }
}
